import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/questiongroup/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paste-from-office/normalizers/googledocsnormalizer
 */
import removeBoldWrapper from "../filters/removeboldwrapper";
import { unwrapParagraphInListItem } from "../filters/list";
import UpcastWriter from '@ckeditor/ckeditor5-engine/src/view/upcastwriter';
var googleDocsMatch = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
/**
 * Normalizer for the content pasted from Google Docs.
 *
 * @implements module:paste-from-office/normalizer~Normalizer
 */

var GoogleDocsNormalizer =
/*#__PURE__*/
function () {
  function GoogleDocsNormalizer() {
    _classCallCheck(this, GoogleDocsNormalizer);
  }

  _createClass(GoogleDocsNormalizer, [{
    key: "isActive",

    /**
     * @inheritDoc
     */
    value: function isActive(htmlString) {
      return googleDocsMatch.test(htmlString);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute(data) {
      var writer = new UpcastWriter();
      removeBoldWrapper(data.content, writer);
      unwrapParagraphInListItem(data.content, writer);
    }
  }]);

  return GoogleDocsNormalizer;
}();

export { GoogleDocsNormalizer as default };